import { useRightDrawer } from "@/contexts/RightDrawerContext";
import { Colors } from "@/enums/Colors";
import { Box, Typography, styled, useMediaQuery, useTheme } from "@mui/material";
import StarIconSvg from "../../../assets/images/star-logo.svg";
import CommonButton from "../utils/CommonButton";

interface Props {
  breadcumbs: string;
}

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: "#F6F8FA !important",
  "&.main-container": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  "&.section-container": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1rem",
  },
}));

const Search = styled("div")(({}) => ({
  borderRadius: "0.5rem",
  border: `solid 1px ${Colors.STROKE_DARK_GRAY}`,
  display: "flex",
  padding: "0.4rem 0.6rem",
  alignItems: "center",
  columnGap: "0.375rem",
  height: "100%",
  width: "14rem !important",
}));

export const LazoAIButton = styled(CommonButton)(({ theme }) => ({
  backgroundColor: Colors.LAZO_PURPLE,
  height: "100%",
  display: "flex",
  justifyContent: "flex-start",
  columnGap: "0.3rem",
  borderRadius: "0.5rem",
  paddingLeft: "0.625rem",
  paddingRight: "1.2rem",
  [theme.breakpoints.down("md")]: {
    height: "auto",
    minHeight: "2.75rem",
    whiteSpace: "normal",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    width: "100%",
    padding: "0.5rem 0.75rem",
    "& .MuiTypography-root": {
      whiteSpace: "normal",
      lineHeight: "1.2",
      wordBreak: "break-word",
    },
    "& > img": {
      flexShrink: 0,
    },
  },
}));

export const AppBarBody = ({ breadcumbs }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const category = breadcumbs.split("/")[0];
  const { isOpen: isOpenRightDrawer, setIsOpen } = useRightDrawer();

  return (
    <Container className="main-container" width={isOpenRightDrawer ? "70.7%" : "100%"}>
      <Typography fontSize="1.5rem" fontWeight="500">
        {category}
      </Typography>
      <Container
        style={{
          height: "2.75rem",
        }}
        className="section-container"
      >
        {/* <Search>
          <SearchIcon sxClass={{ marginBottom: "3px" }} />
          <InputBase
            placeholder={isMobile ? "" : "Search"}
            inputProps={{ "aria-label": "search" }}
          />
        </Search> */}
        {!isOpenRightDrawer && (
          <LazoAIButton onClick={() => setIsOpen(true)}>
            <img src={StarIconSvg.src} style={{ filter: "brightness(100)" }} />
            <Typography textTransform="none" fontWeight={600} color="white">
              Lazo AI
            </Typography>
          </LazoAIButton>
        )}
      </Container>
    </Container>
  );
};
